// extracted by mini-css-extract-plugin
module.exports = {"link":"AboutModal-styles-module--link--3BEWt"};